import {
  isNonNullable
} from "./chunk-K54LRIUM.mjs";

// lib/hooks/use-hover.ts
import { useRef, useState } from "react";
var useHover = (args) => {
  const { delay, leaveDelay } = args ?? {};
  const [hovering, _setHovering] = useState(false);
  const setHovering = (v) => {
    _setHovering(v);
    args?.onChange && args.onChange(v);
  };
  const timeOutId = useRef();
  const onMouseEnter = useRef(() => {
    if (isNonNullable(delay)) {
      timeOutId.current = setTimeout(() => {
        setHovering(true);
      }, delay);
    } else {
      setHovering(true);
    }
  });
  const onMouseLeave = useRef(() => {
    clearTimeout(timeOutId.current);
    if (isNonNullable(leaveDelay)) {
      timeOutId.current = setTimeout(() => {
        setHovering(false);
      }, leaveDelay);
    } else {
      setHovering(false);
    }
  });
  return {
    hovering,
    hoverSensor: {
      onMouseEnter: onMouseEnter.current,
      onMouseLeave: onMouseLeave.current
    }
  };
};

export {
  useHover
};
